import { AbstractFormatPropertyAlert } from "./AbstractFormatPropertyAlert";

export class FormatPropertyTooLongAlert extends AbstractFormatPropertyAlert {
  constructor(propertyKind: string, isError: boolean) {
    super(propertyKind, isError);
  }

  get description(): string {
    return "入力値の長さが最大値を超えています。";
  }
}
